<template>
<div class="row item-view">

	<div class="col-12">
		<partial-loader :loading="isFetching"></partial-loader>
	</div>

	<div class="col"
	     v-show="!isFetching">
		<b-jumbotron class="mb-3 p-4">
			<div class="row">
				<div class="col-2"
				     v-if="item.media && item.media.length">
					<b-carousel controls
					            indicators
					            background="#ababab"
					            :interval="0"
					            img-width="1024"
					            img-height="480">
						<b-carousel-slide v-for="(item, index) in item.media"
						                  :key="index"
						                  :img-src="item.url"></b-carousel-slide>
					</b-carousel>
				</div>

				<div class="col">
					
					<h1 v-if="item.seller"
					    class="display-3">{{ $t('common.item') }} {{ item.seller.code }}-{{ item.number }}</h1>
					<h2>{{ $t('item.auctionOrderNumber') }} {{ item.auction_order_number }}</h2>
					<h2>{{ item.title }}</h2>
					<p>
						<span v-if="item.category != null">{{ item.category.title }}</span>
						<br />
						<small>{{ $t('common.createdAt') }} {{ item.created_at | smallDate }}</small>
						<template v-if="item.tags">
							<br />
							<span class="item-tag" v-for="(tag, i) in item.tags"> {{ tag.name }} </span>
						</template>
					</p>
					<p class="lead">
						{{ item.description }}
					</p>

					<odbbarcode :item="item"  :aucdates="aucdates" :type="'sticker'" />
					<!-- <div class="barc" v-if="aucdates && item.auction_order_number">
						<img src="/static/img/odboom.png" class="odboom" />
						<div class="sticker-head"><span class="aucdates">{{parseAucDates(aucdates)}}</span>Onder de Boompjes</div>
						<div class="lotnr">
							 <span class="lotcode">{{ item.auction_order_number }}</span> 
							 <span class="ibcode">{{ item.seller.code }}-{{ item.number }}</span>
						</div>
						<barcode class="bcode" :width="1.25" :height="26" :margin="0" :value="barcode(item)" :displayValue="false">
						    Show this if the rendering fails.
						</barcode>
					</div> -->

				</div>

				<div class="col-1">

					

					<b-button-group class="pull-right">
						<b-button type="button"
						          v-if="item.previous_id"
						          variant="outline-secondary"
						          v-b-tooltip.hover
						          title="Vorige"
						          :to="{ name: 'item', mode: 'push', params: { itemId: item.previous_id } }">
							<i class="fa fa-fw fa-angle-double-left"></i>
						</b-button>
						<b-button type="button"
						          v-if="item.next_id"
						          variant="outline-secondary"
						          v-b-tooltip.hover
						          title="Volgende"
						          :to="{ name: 'item', mode: 'push', params: { itemId: item.next_id } }">
							<i class="fa fa-fw fa-angle-double-right"></i>
						</b-button>
						<b-button :to="{ name: 'itemEdit' }"
						          v-b-tooltip.hover
						          title="Aanpassen"
						          variant="outline-primary"><i class="fa fa-fw fa-edit"></i></b-button>
						<b-button :to="{ name: 'itemList' }"
						          exact
						          v-b-tooltip.hover
						          title="Terug"
						          variant="outline-secondary"><i class="fa fa-fw fa-reply"></i></b-button>
					</b-button-group>
				</div>
			</div>
		</b-jumbotron>

		<div class="row">

			<div class="col-sm-12 col-lg-6 mb-3"
			     v-if="item.seller">
				<b-jumbotron class=" p-4 h-100">
					<b-btn variant="outline-primary"
					       v-b-tooltip.hover
					       title="Bekijk inbrenger"
					       size="sm"
					       class="pull-right"
					       :to="{ name: 'auctionSeller', params: { personId: item.seller.id }, query: { back: 'auctionSellers' } }"><i class="fa fa-fw fa-eye"></i></b-btn>
					<h2 class="display-4">Inbrenger</h2>

					<div v-if="item.seller">
						<person-info :person="item.seller"></person-info>
					</div>

				</b-jumbotron>
			</div>

			<div class="col-sm-12 col-lg-6 mb-3"
			     v-if="item.bid != null">
				<b-jumbotron class="pt-4 px-4 pb-2 h-100">

					<b-btn-group class="pull-right">
						<b-btn v-if="item.bid.bid_number != null"
						       variant="outline-primary"
						       v-b-tooltip.hover
						       title="Bekijk biednummer"
						       size="sm"
						       :to="{ name: 'auctionBuyer', params: { bidNumber: item.bid.bid_number }, query: { back: 'auctionBuyers' } }"><i class="fa fa-fw fa-eye"></i></b-btn>
						<b-btn variant="outline-primary"
						       v-b-tooltip.hover
						       title="Bod aanpassen"
						       size="sm"
						       :to="{ name: 'bidEdit', params: { bidId: item.bid.id } }"
						       exact><i class="fa fa-fw fa-edit"></i></b-btn>

					</b-btn-group>

					<h2 class="display-4">{{ $t('common.buyer') }}</h2>


					<div v-if="item.bid.buyer">
						<person-info :person="item.bid.buyer.person"></person-info>
					</div>

					<p v-else
					   class="font-italic">
						{{ $t('buyer.noPerson') }}
					</p>

					<hr />

					<h5 v-if="item.bid.bid_number != null">{{ $t('bid.bidNumber') }} {{ item.bid.bid_number }}</h5>

					<span class="pull-left">{{ $t('bid.price') }} <br /><small>{{ item.bid.created_at | smallDate }}</small></span>

					<h3 class="display-4 text-right">&euro;{{ Math.round(item.bid.price) }}</h3>
				</b-jumbotron>
			</div>

			<div class="col mb-3">
				<b-jumbotron class="p-4 h-100">
					<h2 class="display-4 mb-4">{{ $t('common.financial') }}</h2>

					<div v-if="item.target_price_1">
						<h4 class="pull-left">{{ $t('item.targetprice', { number: 1 }) }}</h4>
						<h3 class="display-4 text-right">&euro; {{ Math.round(item.target_price_1) }}</h3>
					</div>

					<div v-if="item.target_price_1">
						<hr />
						<h4 class="pull-left">{{ $t('item.targetprice', { number: 2 }) }}</h4>
						<h3 class="display-4 text-right">&euro; {{ Math.round(item.target_price_2) }}</h3>
					</div>

					<div v-if="item.limit">
						<hr />
						<h4 class="pull-left">{{ $t('item.limit') }}</h4>
						<h3 class="display-4 text-right">&euro; {{ Math.round(item.limit) }}</h3>
					</div>

					<div v-if="item.commission">
						<hr />
						<h4 class="pull-left">{{ $t('item.commission') }}</h4>
						<h3 class="display-4 text-right">&euro; {{ Math.round(item.commission) }}</h3>
					</div>

					<div v-if="item.commission_percentage">
						<hr />
						<h4 class="pull-left">{{ $t('item.commisionPercentage') }}</h4>
						<h3 class="display-4 text-right">{{ item.commission_percentage }}&#37;</h3>
					</div>

				</b-jumbotron>
			</div>

			<div class="col-lg-12 col-xl-6 mb-3">
				<b-jumbotron class="p-4 h-100">
					<b-form-group class="pull-right">
						<b-btn variant="primary"
						       v-b-tooltip.hover
						       :title="$t('pendingBid.add')"
						       exact
						       :to="{ name: 'pendingBidAdd', query: { back: 'item' } }">
							<i class="fa fa-fw fa-plus"></i>
						</b-btn>
					</b-form-group>

					<h2 class="display-4">{{ $t('common.pendingBids') }}</h2>

					<pending-bids></pending-bids>
				</b-jumbotron>
			</div>
		</div>
	</div>
</div>
</template>

<script>
//import VueBarcode from 'vue-barcode';
import { isNil } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
import PartialLoader from '@/components/elements/PartialLoader';
import ODBBarcode from '@/components/elements/ODBBarcode';
import { smallDate } from '@/filters/date-filters.js';
import { setTitle } from '@/helpers/page-helper';
import PendingBids from '@/components/views/Auction/PendingBid/PendingBidListSmall';
import PersonInfo from '@/components/views/Person/PersonInfo';
import { mergeBreadcrumb } from '@/helpers/breadcrumb-helper';

const { mapGetters, mapActions } = createNamespacedHelpers('item');

export default {
	components: {
		PartialLoader,
		PendingBids,
		PersonInfo,
		'odbbarcode' : ODBBarcode,
		//'barcode': VueBarcode,
	},
	filters: {
		smallDate
	},
	data() {
		return {
			pendingBidsFields: [
				{ key: 'created_at', label: this.$t('common.date') },
				{ key: 'pending_bid_number', label: this.$t('pendingBid.number') },
				{ key: 'price', label: this.$t('common.price') },
				{ key: 'buyer', label: this.$t('item.category') }
			],
			currentPage: 1,
			sortBy: 'id',
			sortDesc: true,
			filter: null
		}
	},
	computed: {
		...mapGetters([
			'item',
			'pendingBids',
			'isFetching',
		]),
		itemNumber() {
			return `${this.item.seller.code}-${this.item.number}`;
		}
	},
	watch: {
		'$route': 'init',
		item() {
			mergeBreadcrumb([{}, {}, { meta: { title: this.itemNumber } }]);
		}
	},
	methods: {
		...mapActions([
			'fetchItem',
			'fetchPendingBids',
		]),

		init() {
			this.fetchItem(this.$route.params.itemId).then(() => setTitle(this.$t('item.viewPageTitle', { itemNumber: this.itemNumber })));
			this.fetchPendingBids(this.$route.params.itemId);
		},
		parseAucDates(dates){
			let datestr = '';
			let months = ['','jan','feb','maa','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
			if(typeof dates == 'object' && typeof dates.start != 'undefined'){
				let start = dates.start.substr(0,10).split('-');
				let end = dates.end.substr(0,10).split('-');
				datestr+=parseInt(start[2]) + ' ';
				if(start[1] != end[1]){
					datestr+=months[parseInt(start[1])];
				}
				datestr+=' - ' + parseInt(end[2]) + ' ' + months[parseInt(end[1])] + ' ' + end[0];
				return datestr;
			}
		},
		barcode(item){
			let auctionId 			= this.pad(item.auction_id, 4);
			let paddedItemId 		= this.pad(item.id, 6);
			let paddedSellerID 		= this.pad(item.seller.id, 6);
			let paddedOrderNumber 	= this.pad(item.auction_order_number, 6);
			return auctionId + paddedItemId + paddedSellerID + paddedOrderNumber;
		},
		pad(val,len){
			let padded = String(val);
			while(padded.length < len){
				padded='0' + padded;
			}
			return padded;
		}
	},
	mounted() {
		this.init();
	},
	props : [
		'aucdates'
	]
}
</script>

<style lang="scss" scoped>
.block {
    background-color: #ccc;
}

.item-tag {
	border: 1px solid #4C96E6;
	background: #4C96E6;
	color: white;
	border-radius: 5px;
	padding: 0.2rem 0.5rem;
	margin-right: 0.5rem;
	line-height: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// Item.vue?4209674c